import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { CheckCircle2, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const TABS = [["open", "Open"], ["resolved", "Resolved"], ["all", "All"]];
const CAT = { bug: "text-[#F87171]", idea: "text-[#34D399]", other: "text-[#A8A090]" };

export const FeedbackPanel = () => {
  const qc = useQueryClient();
  const [status, setStatus] = useState("open");
  const { data = [] } = useQuery({ queryKey: ["admin-feedback", status], queryFn: () => api.get("/admin/feedback", { params: { status } }).then((r) => r.data) });
  const toggle = async (f) => { await api.patch(`/admin/feedback/${f.id}`, { resolved: !f.resolved }); qc.invalidateQueries({ queryKey: ["admin-feedback"] }); };
  return (
    <section data-testid="admin-feedback">
      <div className="mb-4 flex gap-2">{TABS.map(([k, l]) => <Button key={k} size="sm" variant={status === k ? "default" : "outline"} onClick={() => setStatus(k)} data-testid={`feedback-filter-${k}`}>{l}</Button>)}</div>
      {data.length === 0 && <p className="text-sm text-[#A8A090]" data-testid="feedback-empty">No feedback here.</p>}
      <div className="space-y-3">
        {data.map((f) => (
          <div key={f.id} className="rounded-md border border-[#2D3442] bg-[#0F131A] p-4" data-testid={`feedback-item-${f.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2 text-xs">
              <span><b className={`uppercase tracking-[0.14em] ${CAT[f.category]}`}>{f.category}</b> <span className="text-[#A8A090]">· {f.name || f.email} ({f.email}) · {new Date(f.created_at).toLocaleString()} · {f.page}</span></span>
              <Button size="sm" variant="ghost" onClick={() => toggle(f)} data-testid={`feedback-resolve-${f.id}`}>{f.resolved ? <><RotateCcw className="mr-1 h-3.5 w-3.5" />Reopen</> : <><CheckCircle2 className="mr-1 h-3.5 w-3.5" />Mark resolved</>}</Button>
            </div>
            <p className="mt-2 whitespace-pre-wrap text-sm text-[#F3EBDD]">{f.message}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
